export const HOST = 'https://impala.asensoft.online'
// export const HOST = 'http://impala.test'
// export const HOST = 'http://localhost:8000'
// export const HOST = 'https://v1.iparraguirre.pro'

export const API_URI = HOST + '/api'

export const API_VERSION = '/v1'

export const API = `${API_URI}${API_VERSION}`

export const COUNTRIES = [{ code: 1, text: 'PERU' }]

export const MAPS_API = 'AIzaSyDPZk55lKjBlyPzmLoSXD_eUIGuv1ts6z8'
